import toPercentSeries from './toPercentSeries'

// Hoeveel maanden terug de groeiregel kijkt. De reeks begint bij de eerste
// registratie ooit — vaak één huishouden — en de groei daartegen is een
// nietszeggend getal van duizenden procenten. Een jaar is de vergelijking die
// een lezer verwacht.
const LOOKBACK_MONTHS = 12

/**
 * @typedef {object} OutcomePoint
 * @property {string} Month - 'YYYY-MM'
 * @property {number} Co2Kg
 * @property {number} PrivateEur
 */

/**
 * De groei van een materiaaluitkomst over (hoogstens) het afgelopen jaar.
 *
 * @param {Array<OutcomePoint>|undefined} series - Cumulatieve maandreeks, oudste eerst
 * @param {'Co2Kg'|'PrivateEur'} field
 * @returns {{value: number, since: string}|null} Procentpunten en de maand waartegen; null als er niets te vergelijken valt
 */
const materialOutcomeTrend = (series, field) => {
    if (!Array.isArray(series)) return null

    const window = series.slice(-(LOOKBACK_MONTHS + 1))
    const percent = toPercentSeries(window.map((p) => ({ month: p.Month, value: p[field] })))
    if (!percent.length) return null

    return { value: percent[percent.length - 1].value, since: percent[0].month }
}

export default materialOutcomeTrend
